import PropTypes from 'prop-types'
import React from 'react'

export function InlineLink({ children, external = false, ...props }) {
  return (
    <a
      {...props}
      className={`me-btn-link-inline${external ? ' me-btn-link-external' : ''}`}
      target={external ? '_blank' : props.target}
      rel={external ? 'noopener noreferrer' : props.rel}
    >
      <span>{children}</span>
      {external && (
        <>
          {'\u00a0'}
          <i
            className="fa-regular fa-arrow-up-right-from-square"
            aria-hidden="true"
          />
          <span className="me-btn-sr-only">
            {' '}
            {window.MEButtons.text('strOpensInNewTab')}
          </span>
        </>
      )}
    </a>
  )
}

InlineLink.propTypes = {
  children: PropTypes.node.isRequired,
  // Opens in a separate tab, with the trailing glyph and its screen-reader
  // text.
  external: PropTypes.bool,
  target: PropTypes.string,
  rel: PropTypes.string,
}
